<template>
	<div>
		<Sticky 
			v-bind:offset='0.5'
			triggerClass='step'
			ActiveClass='entered'
			v-on:enterFn="handleEnterFn">

			<!-- sticky graphic -->
			<template v-slot:sticky>
				<div class="videowrapper">
					<iframe class="knd-story-video" ref="video" src="https://player.vimeo.com/video/646496131?h=519c958a96&title=0&byline=0&portrait=0" width="100%" :height="windowHeight" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
				</div>
			</template>
			
			<template v-slot:steps>
				<div 
					v-for="(stap, index) in content" 
					:key="index"
					class="step video">
					<div class="tekstvak">
						<p v-html="parseTekst(stap.tekst)"></p>
					</div>
				</div>
			</template>
		</Sticky>
	</div>
</template>

<script>
import Sticky from './knd-sticky';

export default {
	name: 'VideoStory',
	props: ['videoUrl', 'content'],
	data() {
		return {
			videoPlay: false
		}
	},
	computed: {
		buurtSelected() {
			return this.$store.getters.buurtSelected;
		},

		gemeenteSelected() {
			return this.$store.getters.gemeenteSelected;
		},

		windowWidth() {
			return window.innerWidth;
		},

		windowHeight() {
			return window.innerHeight;
		}
	},
	mounted () {
	},
	components: {
		Sticky
	},
	methods: {
		handleEnterFn(el) {
			let currentNum = +el.dataset.index + 1;
			// console.log(currentNum);
		},

		parseTekst(tekst) {
			if (this.buurtSelected !== null) {
				tekst = tekst.replace(/\*(.*?)\*/g, (match, token) => {
					return this.tekstCalc(parseInt(token));
				});
			}
			return tekst;
		},

		tekstCalc(token) {
			let vervang;
			const startRed = '<span class="highlightRed">';
			const endRed = '</span>';
			const startBlue = '<span class="highlightBlue">';
			const endBlue = '</span>';

			switch(token) {
				case 1:
					return startBlue + this.gemeenteSelected.gemeente_naam + endBlue;
					// break;
				case 2:
					vervang = this.gemeenteSelected.gemeente_ongezond_2021;
					if (vervang > 1) {
						return startRed + vervang + " ongezonde verkooppunten" + endRed	
					}
					return startRed + vervang + " ongezond verkooppunt" + endRed
					// break;
				case 3:
					vervang = this.buurtSelected.buurt_ongezond_2021;
					if (vervang > 1) {
						return startRed + "staan " + vervang + " ongezonde verkooppunten"  + endRed;	
					}
					return startRed + "staat " + vervang + " ongezond verkooppunt"  + endRed;
					// break;
				case 4:
					return startRed + this.buurtSelected.buurt_ongezond_2021_percentage.toString().replace(".", ",") + endRed;
			}
		}
	}		
}
</script>